import type { HttpGet } from '@/shared/infra/http'
import type { ListMessages } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type MessageDto, toMessage } from './message-dto'

type ListMessagesResponseDto = {
  messages?: MessageDto[]
  nextCursor?: string | null
}

export class EdgeListMessagesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListMessages = async (params) => {
    const search = new URLSearchParams({
      orgId: params.orgId,
      orgType: params.orgType,
    })
    if (params.limit !== undefined) search.set('limit', String(params.limit))
    if (params.cursor) search.set('cursor', params.cursor)
    try {
      const data = await this.http.get<ListMessagesResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/messages?${search.toString()}`,
      })
      return {
        messages: (data?.messages ?? []).map(toMessage),
        nextCursor: data?.nextCursor ?? undefined,
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
